import { select, Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { TeamTemplateModel } from "../_models";
import { TeamTemplateState } from "../_reducers";
import { teamTemplateSelectors } from "../_selectors";
import { TemplateTableDataSource } from "./base-template.datasource";

export class TeamTemplateDataSource extends TemplateTableDataSource<TeamTemplateModel> {
    constructor(private store: Store<TeamTemplateState>) {
        super();
        this.isLoading$ = this.store.select(teamTemplateSelectors.selectIsLoading);
        this.total$ = this.store.select(teamTemplateSelectors.selectTotal);

        this.store.pipe(
            takeUntil(this.destroy$),
            select(teamTemplateSelectors.selectTeamTemplates)
        ).subscribe(res => {
            this.entitySubject$.next(res);
        })
    }
}